export class ImportAudit {
    ID: number;
    FileName: string;
    RecordCount: number;
    FileType: string;
    CreatedDate: Date;
}

export default ImportAudit;